import React, { PropsWithChildren } from 'react'
import { schemaToShape } from '../utils/json-schema'
import { Box } from '../ui'
import { Code, Tooltip, TooltipProps } from '@chakra-ui/react'
import { ReactJSXElement } from '@emotion/react/types/jsx-namespace'

type JsonSchemaTooltipProps = TooltipProps & {
  config: TenantConfiguration
}

export function JsonSchemaTooltip({
  config,
  children,
  ...props
}: PropsWithChildren<JsonSchemaTooltipProps>): ReactJSXElement {
  return (
    <Tooltip label={buildSchema(config)} aria-label={config.description} {...props}>
      {children}
    </Tooltip>
  )
}

function buildSchema(config: TenantConfiguration): React.ReactNode {
  const schema = config.schema

  if (!schema) {
    return config.description
  }

  let formattedSchema = null

  try {
    const parsedSchema = JSON.parse(schema)
    const normalized =
      Array.isArray(parsedSchema.items) && parsedSchema.items.length === 1
        ? { ...parsedSchema, items: parsedSchema.items[0] }
        : parsedSchema

    formattedSchema = schemaToShape(normalized)
  } catch {
    console.error('Invalid json schema')
  }

  if (!formattedSchema) {
    return config.description
  }

  return (
    <Box maxW="320px">
      {config.description}
      <Box mt={2}>
        <Box fontWeight="semibold">Schema</Box>
        <Code as="pre" display="block" fontSize="xs" whiteSpace="pre-wrap" my={1}>
          {formattedSchema}
        </Code>
      </Box>
    </Box>
  )
}
